// @ts-nocheck
import componentsReducer, { GreifComponentsActions } from "@store/Framework/Store/Greif/Components/ComponentsReducer";
import dataReducer, { GreifDataActions } from "@store/Framework/Store/Greif/Data/DataReducer";
import pagesReducer, { GreifPagesActions } from "@store/Framework/Store/Greif/Pages/PagesReducer";
import { combineReducers } from "redux";

const greifReducers = {
    components: componentsReducer,
    data: dataReducer,
    pages: pagesReducer,
};

export type GreifActions = GreifComponentsActions | GreifDataActions | GreifPagesActions;
export default combineReducers(greifReducers);
